
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
// import ICU from 'i18next-icu'; // si besoin de messages ICU

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  // .use(ICU) // active si tu utilises ICU
  .use(initReactI18next)
  .init({
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en'],
    ns: ['common', 'home', 'translation'],
    defaultNS: 'translation',
    load: 'currentOnly',
    debug: import.meta.env.DEV,
    interpolation: {
      escapeValue: false, // React s’occupe du XSS
    },
    detection: {
      // ordre recommandé : query -> localStorage -> navigateur
      order: ['querystring', 'localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupQuerystring: 'lang',
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    react: {
      useSuspense: true, // facilite le lazy loading
    },
  });

export default i18n;
